const cadastro_escola_contraturno = {
  path: "/cadastro-de-escola-contraturno",
  redirect: "/cadastro-de-escola-contraturno",
  meta: {
    breadCrumb: "Planejamento Matricula - Tabelas de Apoio ao Planejamento",
  },
  children: [
    {
      path: "/cadastro-de-escola-contraturno",
      name: "cadastro-de-escola-contraturno",
      meta: {
        allowedPermissions: ["geracao_de_vagas"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroEscolaContraTurno/CadastroEscolaContraTurnoHome.vue"
        ),
    },
    {
      path: "/cadastro-de-escola-contraturno-novo",
      name: "cadastro-de-escola-contraturno-novo",
      meta: {
        allowedPermissions: ["geracao_de_vagas"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroEscolaContraTurno/CadastroEscolaContraTurnoCreate.vue"
        ),
    },
    {
      path: "/cadastro-de-escola-contraturno-editar/:id",
      name: "cadastro-de-escola-contraturno-editar",
      meta: {
        allowedPermissions: ["geracao_de_vagas"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroEscolaContraTurno/CadastroEscolaContraTurnoUpdate.vue"
        ),
    },
  ],
};

export { cadastro_escola_contraturno };
